import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { NoWrap, SecondaryTextXs300 } from 'atoms';

const template = styled.div`
`;

export default Molecule({
  template,
  atoms: [
    {
      component: NoWrap,
      name: 'Category',
      displayValue: ({ category }) => category,
    },
    {
      component: SecondaryTextXs300,
      name: 'ParentCategory',
      displayValue: ({ parent }) => parent,
    },
  ],
})